import * as React from 'react'
import { IControlProps } from './types'
import { formatDate } from '../../utils/dates'
import { GRID_CELLPADDING, GRID_CELLFONTSIZE } from './grids/consts'
import { CONFIG } from '../../config'
import TimePicker from '../common/TimePicker'

export interface IAntdTimeControlState {
  value: any
}

export default class AntdTimeControl extends React.Component<
  IControlProps,
  IAntdTimeControlState
> {
  timeFormat: string
  constructor(props: any) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
    if (props.timeFormat) {
      this.timeFormat = props.timeFormat
    } else {
      this.timeFormat = CONFIG.displayTimeFormat
    }
    const initialValue = this.fromStoredValue(this.props.field.value || '')
    this.state = {
      value: initialValue == '' ? null : initialValue
    }
  }

  fromStoredValue(value: string) {
    if (!value || value.length === 0) {
      return ''
    }
    const dateParts = value.split(':')
    const d = new Date()
    d.setHours(Number(dateParts[0]))
    d.setMinutes(Number(dateParts[1]))
    d.setSeconds(dateParts[2] ? Number(dateParts[2]) : 0)
    return d
  }

  toStoredValue(value: Date | null): string {
    return value instanceof Date && !isNaN(value.getTime())
      ? formatDate('time', value)
      : ''
  }

  handleChange(date: Date | null) {
    if (date !== null) {
      this.props.form.setFieldValue(
        this.props.field.name,
        this.toStoredValue(date)
      )
    } else {
      this.props.form.setFieldValue(
        this.props.field.name,
        this.toStoredValue(null)
      )
    }

    this.setState({ value: date })
  }

  render() {
    if (this.props.gridCell) {
      const value = this.fromStoredValue(this.props.field.value || '')
      const displayValue = value
        ? formatDate('display_time', value, this.timeFormat)
        : ''
      return (
        <div
          id={this.props.id}
          style={{ padding: GRID_CELLPADDING, fontSize: GRID_CELLFONTSIZE }}
        >
          {displayValue}
        </div>
      )
    } else {
      return (
        <TimePicker
          id={this.props.id}
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          value={this.state.value}
          onChange={(date) => this.handleChange(date)}
          displayFormat={this.timeFormat}
          valueFormat={this.timeFormat}
          style={{
            borderRadius: '4px',
            boxSizing: 'border-box',
            marginTop: '20px'
          }}
          size='large'
          disabled={this.props.disabled}
          inputReadOnly={true}
        />
      )
    }
  }
}
